import { LoginContainer } from "../containers/LoginContainer";
export function LoginPage() {
    return (
        <LoginContainer />
    );

}